module.exports = __webpack_public_path__ + "static/img/baojingjiechu2.365fa99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/baojingjiechu2.png
// module id = ntpD
// module chunks = 24